import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";

export const MindmapDisplayRecord = Record({
  nodes: List(),
  connectors: List(),
  rect: FlatRectRecord()
});

const data = {
  collections: {
    nodes: "MindmapNodeDisplayRecord",
    connectors: "MindmapConnectorDisplayRecord"
  },
  objects: {
    rect: "FlatRectRecord"
  }
};
createFromJS.registerCallback("MindmapDisplayRecord", createFromJS.createNestedCallback(MindmapDisplayRecord, data));
